<div class="raptor-sidebar-container radius-block">
  <div class="sidebar-container" #container [ngClass]="{ 'sidebar-container-opened': !collapsed, 'sidebar-collapsed': collapsed }" (click)="toggleView($event)">
    <div class="raptor-sidebar-mobile-details-link show-for-medium-down text-center padding-medium" [ngClass]="{ 'details-link-collapsed': collapsed }">
      <ng-container *ngIf="collapsed"><mat-icon class="expand_less margin-top-medium"></mat-icon></ng-container>
      <ng-container *ngIf="!collapsed"><mat-icon class="close"></mat-icon></ng-container>

    </div>
    <div *ngFor="let section of sidebar.sections">
      <div [ngSwitch]="section.layout">
        <div *ngSwitchCase="'other'"></div>

        <div *ngSwitchDefault>
          <open-raptor-sidebar-section-default
            [section]="section"
            [form]="form"
            [collapsed]="collapsed">
          </open-raptor-sidebar-section-default>
        </div>
      </div>

    </div>
  </div>
</div>

<div class="show-for-medium-down raptor-sidebar-mobile-overlay-container" [ngClass]="!collapsed ? 'overlay-visible' : 'overlay-hidden'">
  <div class="raptor-sidebar-mobile-overlay" (click)="toggleView($event)"></div>
</div>
